
import React from "react";
import Header from "../Home/Header/header.jsx";
import Main from "./Main/main";


function SignIn() {
    return (
        <div>
            <Header/>
            <Main />
        </div>
    );
}

export default SignIn;
